import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { UserService } from './services/userService.service';
import { UserModel } from '@src/models/user.model';
import { LoginModel } from '@src/models/login.model';
import { KBWMonitoringService } from './services/logging.service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [UserService],
    standalone: false
})
export class AppComponent {
  currentUser: UserModel;
  systemUser: LoginModel;

  constructor(
    private KBWMonitoringService: KBWMonitoringService,
    public translate: TranslateService,
    private router: Router,
    private userService: UserService
  ) {
    this.userService.currentUser.subscribe(x => this.currentUser = x);
    this.userService.systemUser.subscribe(x => this.systemUser = x);
    translate.addLangs(['en-GB', 'pl-PL']);

    const lang = sessionStorage.getItem('lang');
    if (!lang) {
      sessionStorage.setItem('lang', 'pl-PL');
      translate.setDefaultLang('pl-PL');
    } else {
      translate.setDefaultLang(lang);
    }
  }

  logout(){
    this.userService.logout();
    this.router.navigate(['/']);
  }
}
